angular.module('cimerFrontEndApp').service('AdministratorService', ['$http', 'ApiUrl', function ($http, ApiUrl) {
    'use strict';

    var _divisionApi = ApiUrl.url('/Division/');
    var _projectApi = ApiUrl.url('/Project/');

    this.GetDivisionsForAdmin = function () {
        return $http.get(_divisionApi + "GetDivisionsByProjects").then(function (response) {
            if (!response) {
                return [];
            }
            return response.data;
        });
    };

    this.GetDivisionByID = function(divisionID) {
        return $http.get(_divisionApi + "GetDivisionByID/" + divisionID)
            .then(function(response) {
                if (!response) {
                    return null;
                }
                return response.data;
            });
    };

    this.GetAllProjects = function () {
        return $http.get(_projectApi + "AllProjects").then(function (response) {
            if (!response) {
                return [];
            }
            return response.data;
        });
    };

}]);